export const supportedLocales = <const>['en', 'de', 'pt-BR', 'es'];

export const extendedSupportedLocales = <const>[
  'en',
  'en-STAGING',
  'pt-BR',
  'pt-STAGING',
  'de',
  'de-STAGING',
  'es',
  'es-STAGING',
  'cimode',
];

export const getSupportedLocales = (): readonly string[] => {
  // we get localization-dev-mode flag directly from localStorage
  const extendedLocalesFlag = window.localStorage.getItem(
    'HJ_OVERRIDE_FEATURE:localization-dev-mode',
  );

  return extendedLocalesFlag === '1' || extendedLocalesFlag === 'true'
    ? extendedSupportedLocales
    : supportedLocales;
};

export const getParsedLanguage = (foundLang?: string): string | undefined => {
  const supportedLocs = getSupportedLocales();

  if (foundLang !== undefined) {
    const justLang = foundLang.slice(0, 2);
    const isFoundLangSupported = supportedLocs.includes(foundLang);
    const isJustLangSupported = supportedLocs.includes(justLang);
    const parsedLang = isJustLangSupported ? justLang : supportedLocs[0];

    return isFoundLangSupported ? foundLang : parsedLang;
  }

  return undefined;
};
